import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { Login } from './components/auth/Login';
import { Signup } from './components/auth/Signup';
import { Dashboard } from './components/dashboard/Dashboard';
import { LandingPage } from './components/landing/LandingPage';
import { SubscriptionDetailsPage } from './components/subscription/SubscriptionDetailsPage';
import { Layout } from './components/layout/Layout';
import { AboutPage } from './components/about/AboutPage';
import { ServicesPage } from './components/services/ServicesPage';
import { FAQPage } from './components/faq/FAQPage';
import { SolicitationPage } from './components/solicitation/SolicitationPage';
import { PrivacyPage } from './components/legal/PrivacyPage';
import { TermsPage } from './components/legal/TermsPage';
import { SupportPage } from './components/legal/SupportPage';
import { CreditsSuccessPage } from './components/credits/CreditsSuccessPage';
import { CreditsCanceledPage } from './components/credits/CreditsCanceledPage';
import { darkTheme } from './theme/darkTheme';

console.log('[GovToolsPro] App.tsx loading...');
console.log('[GovToolsPro] darkTheme:', darkTheme ? 'loaded' : 'MISSING');

function App() {
  console.log('[GovToolsPro] App component rendering...');
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/plans" element={<SubscriptionDetailsPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/support" element={<SupportPage />} />
              <Route path="/credits-success" element={<CreditsSuccessPage />} />
              <Route path="/credits-canceled" element={<CreditsCanceledPage />} />
              <Route
                path="/analyze"
                element={
                  <ProtectedRoute>
                    <SolicitationPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Layout>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
